// Restaura construtores nativos de WebRTC caso o sandbox do Discord (discordsays.com) tenha sobrescrito com null
if (typeof window !== 'undefined') {
  let bridgeFrame: HTMLIFrameElement | null = null;
  function getCleanScope() {
    if (!bridgeFrame || !bridgeFrame.isConnected) {
      let frame = document.getElementById('nexia-webrtc-bridge') as HTMLIFrameElement | null;
      if (!frame) {
        frame = document.createElement('iframe');
        frame.id = 'nexia-webrtc-bridge';
        frame.style.display = 'none';
        frame.style.position = 'absolute';
        frame.style.width = '0';
        frame.style.height = '0';
        frame.style.border = 'none';
        (document.body || document.documentElement).appendChild(frame);
      }
      bridgeFrame = frame;
    }
    return bridgeFrame.contentWindow as any;
  }

  function restoreWebRtc() {
    const w = window as any;
    if (typeof w.RTCPeerConnection !== 'function') {
      try {
        const cw = getCleanScope();
        if (cw && typeof cw.RTCPeerConnection === 'function') {
          w.RTCPeerConnection = cw.RTCPeerConnection;
          if (cw.RTCSessionDescription) w.RTCSessionDescription = cw.RTCSessionDescription;
          if (cw.RTCIceCandidate) w.RTCIceCandidate = cw.RTCIceCandidate;
          if (cw.MediaStream) w.MediaStream = cw.MediaStream;
          if (cw.RTCRtpReceiver) w.RTCRtpReceiver = cw.RTCRtpReceiver;
          console.log('[Nexia WebRTC] Construtores nativos de WebRTC restaurados com sucesso via bridge persistente!');
        }
      } catch (e) {
        console.warn('[Nexia WebRTC] Falha ao restaurar WebRTC nativo:', e);
      }
    }
  }

  restoreWebRtc();
  window.addEventListener('DOMContentLoaded', restoreWebRtc);
  window.addEventListener('load', restoreWebRtc);
}

import { createApp } from 'vue';
import App from './App.vue';
import './style.css';

createApp(App).mount('#app');
